import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import backArrowImg from "../../assets/images/common/recommand_right-arrow.png";
import beginerImg from "../../assets/images/common/beginer_level.png";
import hoursImg from "../../assets/images/common/clock.png";
import flextimeImg from "../../assets/images/common/flex_schedule.png";
import "../../../../features2/recommendation/recommendation_industry_view/recommendation_indusview_styles/Recommendation_ViewHeader_Styles.css";
import quesIcon from "../../../sidebar/assets/blueQuesIcon.png";
import { useSelector } from "react-redux";
import analytics_strings from "../../../../analytics/analytics_strings";
import { logActionEvent } from "../../../../analytics/analytics_utils";
import { RootState } from "../../../../store/store";
import RightModal from "../../needHelp/pages/NeedHelpPage";
interface RecommendationViewHeaderProps {
  hours: string;
  text?: string; // Dynamic hours prop
  onClick?: () => void;
}

const RecommendationViewHeader: React.FC<RecommendationViewHeaderProps> = ({
  hours,
  text,
  onClick,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isModalOpen, setModalOpen] = useState(false);
  // Select the data from the Redux store
  const userData = useSelector((state: RootState) => state.profile.profileKeys);

  return (
    <div>
      <header>
        <div className="header-container">
          <div className="home-section">
            {(location.pathname ===
              "/dashboard/recommendation/jozunaview/video" ||
              location.pathname ===
                "/dashboard/recommendation/jozunaview/course") && (
              <div
                className="back-arrow-container"
                style={{ marginRight: "10px" }}
                onClick={onClick}
              >
                <img
                  src={backArrowImg}
                  alt="Back"
                  style={{
                    width: "24px",
                    height: "24px",
                    // marginRight: "8px",
                    cursor: "pointer",
                    alignItems: "center",
                  }}
                  onClick={onClick}
                />
              </div>
            )}
            <div>
              <span
                className="home-text"
                style={{
                  marginLeft: "0px",
                  color: "#2d2d2d",
                  fontSize: "20px",
                  fontWeight: 500,
                  fontFamily: "Mazzard",
                }}
              >
                {text}
              </span>
              {location.pathname !==
                "/dashboard/recommendation/jozunaview/course" &&
                location.pathname !==
                  "/dashboard/recommendation/jozunaview/video" && (
                  <div
                    style={{
                      marginLeft: "0px",
                      color: "#344054",
                      fontSize: "14px",
                      fontWeight: 300,
                    }}
                    className="home-text"
                  >
                    Develop yourself into a career ready dynamic personality
                    with your personalized learning outcomes
                  </div>
                )}
            </div>
          </div>
          {/* <img
  src={quesIcon} // put your image path here
  alt="Recommendations"
  style={{
    width: "40px",
    height: "40px", // adjust size as needed
    marginRight: "",
    cursor: "pointer",
  }}
                 onClick={()=>{toggleModal()}}

/> */}
        </div>
      </header>
      {/* <RightModalRecommendation
                  isOpen={isModalOpen}
                  toggleModal={toggleModal}
                /> */}
    </div>
  );
};

export default RecommendationViewHeader;
